import React, { ReactNode } from "react";
import { Pill, SpotlightRoundelOnDarkBgSvg } from "component-library";
import cx from "classnames";

import "./BreakdownTitle.scss";

export interface IBreakdownTitleProps {
  title: string;
  sentBy: string;
  closingDate: ReactNode;
  exclusive: boolean;
  exclusiveText: string;
  exclusiveTitle?: string;
  isPrintView?: boolean;
}

const BreakdownTitle: React.FC<
  React.PropsWithChildren<IBreakdownTitleProps>
> = (props) => {
  return (
    <div
      className={cx("c-breakdown-title", {
        "c-breakdown-title--print": props.isPrintView,
      })}
    >
      <div className="c-breakdown-title__main">
        <h1>{props.title}</h1>
        <div className="flex flex-col md:gap-4 md:flex-row">
          <div className="flex flex-col">
            <p>{props.sentBy}</p>
            <p>{props.closingDate}</p>
          </div>
          <div className="flex gap-1">
            {props.exclusive && (
              <div className="c-breakdown-title__aside">
                <Pill
                  title={props.exclusiveTitle}
                  icon={SpotlightRoundelOnDarkBgSvg}
                  size="lg"
                  theme="dark"
                >
                  {props.exclusiveText}
                </Pill>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakdownTitle;
